
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { PackageVersionMilestoneSource } from '@/Sources';
  import { IPackageVersionMilestone } from '@/Interfaces';
  import { format as dateFormat } from 'date-fns';

  @Component({
    name: 'package-version-milestone-dp-field',
    components: { Field, DropdownField }
    
  })
  export default class PackageVersionMilestoneDpField extends Vue {
    @Prop() public value!: IPackageVersionMilestone;
    @Prop({ default: 'PackageVersion' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop({ type: Boolean, default: false }) public inline!: boolean;
    @Prop({ type: Boolean, default: false }) public clearable!: boolean;
    @Prop() public placeholder!: string;
    @Prop() public packageId!: string;
    @Prop() public source!: PackageVersionMilestoneSource | undefined | null;

    public packageVersionSource: PackageVersionMilestoneSource | IPackageVersionMilestone[] = [];

    public get val(): IPackageVersionMilestone { return this.value; }
    public set val(value: IPackageVersionMilestone) {
      this.$emit('input', value);
    }

    public onDataLoad() {
      this.$emit('init');
    }

    @Watch('packageId', { immediate: true })
    public onPackageIdChanged(newPackageId: string | undefined) {
      if (this.source === undefined) {
        if (newPackageId) {
          this.packageVersionSource = new PackageVersionMilestoneSource(newPackageId);
        } else {
          this.packageVersionSource = [];
        }
      }
    }

    @Watch('source', { immediate: true })
    public onSourceChanged(newSource: PackageVersionMilestoneSource | undefined | null) {
      if (newSource !== undefined && newSource !== null) {
        this.packageVersionSource = newSource;
      } else {
        setTimeout(() => this.onPackageIdChanged(this.packageId));
      }
    }

    public formatDate(date: string) {
      return dateFormat(new Date(date), 'MM-dd-yyyy hh:mm aa');
    }
  }
